<template>
  <div class="c17 doc-content">
    <p class="c2"><span class="c5">TERMS AND CONDITIONS</span></p>
    <p class="c3"><span class="c1">Effective from: 7 April 2026</span></p>
    <p class="c0">
      <span class="c1"
        >These Terms and Conditions ("Agreement" or "Terms") is an agreement between you and Techss
        Limited (hereinafter "Techss") and applies to your use of the website at </span
      ><span class="c14"><a class="c15" href="https://techss.co/">https://techss.co/</a></span
      ><span class="c1"> (referred to herein below as the "website").</span>
    </p>
    <p class="c0">
      <span class="c1"
        >Please read carefully, agree and accept all the terms and conditions contained in this
        Agreement and the Privacy Policy contained on the website, which are an integral part of
        this Agreement, before you use the services provided by Techss.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >These Terms apply in full force and effect to your use of this website and by using this
        website, you expressly accept all terms and conditions contained herein in full. You must
        not use this website, if you have any objection to any of these Terms.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >You understand and agree that your access to and use of the website is entirely at your own
        discretion and risk, and that you will be solely responsible for any loss or damage that may
        arise from such access and use.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >Please note that any actions on the website that are made by using your Internet connection
        or electronic device, unless you prove otherwise, shall be deemed as have been taken by
        you.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >The following definitions will apply here: "you" or "your" means any natural person or
        entity using the website ("Client"), unless otherwise stated herein. "Techss", "we", "our",
        "Company" or "Partners" together will refer to Techss and its subsidiaries, Partners, unless
        otherwise stated.</span
      >
    </p>

    <p class="c0"><span class="c5">Information about us</span></p>
    <p class="c0">
      <span class="c1"
        >This website is owned and maintained by Techss Limited, a company incorporated under the
        laws of Seychelles, with the registered office at: 306, Victoria House, Victoria, Mahe,
        Seychelles, registration number 242334.</span
      >
    </p>

    <p class="c0"><span class="c5">Acceptable Use of the Website</span></p>
    <p class="c0">
      <span class="c1"
        >Access to and use of the Website is conditional upon compliance with these Terms. Any use
        that compromises the integrity, security, or lawful operation of the Website, or that
        adversely affects the Company or third parties, is strictly prohibited.</span
      >
    </p>

    <p class="c0"><span class="c5">1. Lawful Use Requirement</span></p>
    <p class="c0">
      <span class="c1"
        >The Website may only be used in a manner that is consistent with applicable laws and
        regulations. Any activity that is unlawful, misleading, or harmful is not permitted.</span
      >
    </p>

    <p class="c0"><span class="c5">2. Prohibited Conduct</span></p>
    <p class="c0">
      <span class="c1"
        >Without limitation, users must refrain from engaging in any of the following:</span
      >
    </p>
    <ul class="c7 lst-kix_list_3-0 start">
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(a) Misuse of identity or representation — Presenting oneself as the Company, its
          representatives, another user, or any third party, whether directly or indirectly,
          including through the use of misleading contact details or identifiers.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(b) Improper communications — Using the Website as a channel for distributing unsolicited
          communications, including advertising, bulk messaging, or similar forms of outreach not
          expressly authorized.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(c) Harmful or inappropriate content — Publishing, transmitting, or otherwise making
          available any material that may be considered offensive, abusive, defamatory,
          discriminatory, threatening, or otherwise inappropriate in nature.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(d) Interference with user experience — Engaging in behavior that limits or disrupts
          other users' ability to access or use the Website, or that may expose the Company or its
          users to legal or operational risks.</span
        >
      </li>
    </ul>

    <p class="c0"><span class="c5">3. Technical and System Restrictions</span></p>
    <p class="c0">
      <span class="c1"
        >Users are not permitted to interact with the Website in a manner that interferes with its
        technical infrastructure or performance. In particular, the following actions are
        prohibited:</span
      >
    </p>
    <ul class="c7 lst-kix_list_3-0">
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(a) Automated access and extraction — Using scripts, bots, crawlers, or similar automated
          mechanisms to access, collect, or monitor Website data.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(b) Unauthorized data use — Reproducing, copying, or extracting Website content through
          manual or automated means without prior written approval.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(c) System disruption — Taking any action that may overload, damage, disable, or
          otherwise impair the functionality or availability of the Website.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(d) Introduction of malicious elements — Uploading or transmitting any software, code, or
          material designed to disrupt, damage, or gain unauthorized control over systems, including
          viruses or similar harmful components.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(e) Unauthorized access attempts — Attempting to gain access to restricted areas of the
          Website, its servers, or any connected systems or databases without authorization.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(f) Network attacks — Engaging in any form of attack intended to disrupt service
          availability, including denial-of-service (DoS) or distributed denial-of-service (DDoS)
          activities.</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >(g) General interference — Any conduct aimed at undermining the security, stability, or
          proper functioning of the Website.</span
        >
      </li>
    </ul>

    <p class="c0"><span class="c5">Intellectual Property</span></p>
    <p class="c0">
      <span class="c1"
        >Techss own all rights to the intellectual property and material contained in this website,
        and all such rights are reserved. You are granted a limited license only, subject to the
        restrictions provided in these Terms, for purposes of viewing the material contained on this
        website. You must not republish material from this website (including republication on
        another website), or reproduce or store material from this website in any public or private
        electronic retrieval system; you must not reproduce, duplicate, copy, sell, re-sell, visit,
        or otherwise exploit our website or material on our website for a commercial purpose,
        without our express written consent. Elements of the website are protected by trade dress,
        trade secret and other laws and may not be copied or imitated in whole or in part. All
        custom graphics, icons, and other items that appear on the website are trademarks, service
        marks or trade dress of Techss and may not be used or interfered with in any manner without
        the express written consent of Techss.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >In consideration of this, users agree that copies of the information will retain all
        copyright and other proprietary notices.</span
      >
    </p>

    <p class="c0"><span class="c5">Legal terms</span></p>
    <p class="c0">
      <span class="c1"
        >This website may contain other proprietary notices and copyright information, the terms of
        which must be observed and followed. Information on this website may contain typographical
        errors or technical inaccuracies. Information may be changed or updated without
        notice.</span
      >
    </p>

    <p class="c0">
      <span class="c5">Indemnification, Warranties and Limitation of Liability</span>
    </p>
    <p class="c0">
      <span class="c1"
        >You agree to indemnify, defend and hold harmless Techss from and against any claims,
        liabilities, damages, losses, and expenses (including reasonable legal fees) arising out of
        or in connection with your breach of these Terms or your use or misuse of the Website.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >The Website and all content made available through it are provided on an "as is" and "as
        available" basis. To the fullest extent permitted by applicable law, Techss makes no
        representations or warranties, whether express or implied, in relation to the Website or its
        content, including (without limitation) any warranties of accuracy, completeness,
        reliability, availability, or fitness for a particular purpose. Techss does not guarantee
        that the Website will meet your expectations, that access will be uninterrupted or secure,
        or that any defects will be corrected.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >The content on the Website is provided for general informational purposes only and does not
        constitute legal, financial, medical, or other professional advice. You should seek
        independent professional advice where appropriate.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, TECHSS SHALL NOT BE LIABLE FOR ANY
        INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL LOSS OR DAMAGE ARISING OUT OF OR IN
        CONNECTION WITH THE USE OF, OR INABILITY TO USE, THE WEBSITE OR ANY LINKED RESOURCES,
        INCLUDING (WITHOUT LIMITATION) ANY LOSS OF PROFITS, REVENUE, BUSINESS OPPORTUNITIES,
        BUSINESS INTERRUPTION, OR LOSS OR CORRUPTION OF DATA, EVEN IF TECHSS HAS BEEN ADVISED OF THE
        POSSIBILITY OF SUCH LOSS OR DAMAGE.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >TECHSS DOES NOT CONTROL AND IS NOT RESPONSIBLE FOR THE CONTENT, AVAILABILITY, OR PRACTICES
        OF ANY THIRD-PARTY WEBSITES.</span
      >
    </p>
    <p class="c0">
      <span class="c1"
        >Nothing in these Terms shall exclude or limit liability where such exclusion or limitation
        would be unlawful. Where liability cannot be excluded, Techss's total aggregate liability
        arising out of or in connection with the Website or these Terms shall be limited to the
        amount paid by you (if any) for access to or use of the Website or related services.</span
      >
    </p>

    <p class="c0"><span class="c5">Breach of Terms</span></p>
    <p class="c0">
      <span class="c1"
        >If you fail to comply with these Terms, we reserve the right to take any action we consider
        appropriate to address such breach.</span
      >
    </p>
    <p class="c0"><span class="c1">Such actions may include, without limitation:</span></p>
    <ul class="c7 lst-kix_list_3-0">
      <li class="c11 li-bullet-0">
        <span class="c1"
          >suspending or restricting your access to the Website (temporarily or permanently);</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >blocking or limiting access from specific users, IP addresses, or devices;</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >removing or restricting any content associated with your use of the Website;</span
        >
      </li>
      <li class="c11 li-bullet-0">
        <span class="c1"
          >taking legal action or pursuing any other remedies available under applicable law.</span
        >
      </li>
    </ul>
    <p class="c0">
      <span class="c1"
        >We may exercise these rights at our sole discretion and without prior notice where
        reasonably necessary to protect the Website, the Company, or its users.</span
      >
    </p>

    <p class="c0"><span class="c5">Waiver</span></p>
    <p class="c0">
      <span class="c1"
        >Failure to enforce any of the provisions set out in these Terms and Conditions and any
        Agreement, or failure to exercise any option to terminate, shall not be construed as waiver
        of such provisions and shall not affect the validity of these Terms and Conditions or of any
        Agreement or any part thereof, or the right thereafter to enforce each and every
        provision.</span
      >
    </p>

    <p class="c0"><span class="c5">Modifications</span></p>
    <p class="c0">
      <span class="c1"
        >We can revise and update these Terms at any time without notice. In case of any changes,
        amendments, modifications, or corrections, we will post the revised version of the Terms on
        the website. It is your responsibility to check these Terms for any changes whenever you
        access the website. Your continued usage of the website after any changes to these Terms of
        Use will mean you accept those changes</span
      >
    </p>

    <p class="c0"><span class="c5">Contact us</span></p>
    <p class="c0">
      <span class="c1"
        >Any questions, comments and requests regarding these Terms should be addressed by writing
        to us by sending an e-mail to: </span
      ><span class="c14"><a class="c15" href="mailto:info@techss.co">info@techss.co</a></span>
    </p>
  </div>
</template>

<script setup></script>

<style lang="stylus" scoped>

ul.lst-kix_list_3-0 {
  list-style-type: none
}

.lst-kix_list_3-0 > li:before {
  content: "\0025cf   "
}

li.li-bullet-0:before {
  margin-left: -17.9pt;
  white-space: nowrap;
  display: inline-block;
  min-width: 17.9pt
}

ol {
  margin: 0;
  padding: 0
}

table td, table th {
  padding: 0
}

.c11 {
  margin-left: 35.9pt;
  padding-top: 0pt;
  padding-left: -0.1pt;
  padding-bottom: 6pt;
  line-height: 1.0791666666666666;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c1 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
  font-style: normal
}

.c5 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
  font-style: normal
}

.c2 {
  padding-top: 0pt;
  padding-bottom: 12pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: center
}

.c3 {
  padding-top: 0pt;
  padding-bottom: 8pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left
}

.c0 {
  padding-top: 0pt;
  padding-bottom: 8pt;
  line-height: 1.0791666666666666;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c14 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  color: #0563c1;
  text-decoration: underline
}

.c17 {
  background-color: #ffffff;
  max-width: 960rem;
  position relative;
  left 50%;
  transform translate(-50%);
  margin-top: 30rem;
}

.c15 {
  color: inherit;
  text-decoration: inherit
}

.c7 {
  padding: 0;
  margin: 0
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
}

a {
  color #00c853!important
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}

@media (max-width: 960px) {
  .c17 {
    width 90%
    left 5%
    transform none
    padding 0
  }
}
</style>
